import type { ReactNode } from "react";
import { regions, sortOptions, years, typeLabels } from "@/mocks/videos";

interface FilterPanelProps {
  type: string;
  region: string;
  year: string;
  sort: string;
  onTypeChange: (value: string) => void;
  onRegionChange: (value: string) => void;
  onYearChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onClear: () => void;
}

const typeKeys = ["movie", "tv", "variety"];

function Chip({
  active,
  children,
  onClick,
}: {
  active: boolean;
  children: ReactNode;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs md:text-sm transition-colors ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
      }`}
    >
      {children}
    </button>
  );
}

export default function FilterPanel({
  type,
  region,
  year,
  sort,
  onTypeChange,
  onRegionChange,
  onYearChange,
  onSortChange,
  onClear,
}: FilterPanelProps) {
  const groupTitle = "mb-2.5 font-heading text-sm font-semibold text-foreground-950";

  return (
    <div className="space-y-6">
      <div>
        <h3 className={groupTitle}>类型</h3>
        <div className="flex flex-wrap gap-2">
          {typeKeys.map((key) => (
            <Chip key={key} active={type === key} onClick={() => onTypeChange(key)}>
              {typeLabels[key]}
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <h3 className={groupTitle}>地区</h3>
        <div className="flex flex-wrap gap-2">
          {regions.map((item) => (
            <Chip key={item} active={region === item} onClick={() => onRegionChange(item)}>
              {item}
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <h3 className={groupTitle}>年份</h3>
        <div className="flex flex-wrap gap-2">
          {years.map((item) => (
            <Chip key={item} active={year === item} onClick={() => onYearChange(item)}>
              {item}
            </Chip>
          ))}
        </div>
      </div>

      <div>
        <h3 className={groupTitle}>排序</h3>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((item) => (
            <Chip key={item.key} active={sort === item.key} onClick={() => onSortChange(item.key)}>
              {item.label}
            </Chip>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={onClear}
        className="inline-flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        <i className="ri-refresh-line" />
        清除筛选条件
      </button>
    </div>
  );
}